/**
 * home.js — トップページでだけ必要な軽量処理。
 * 共通 site.js から分離し、下層ページの実行・配信コストを抑える。
 */
(function () {
  'use strict';

  function initFacilityPosition() {
    var list = document.querySelector('.facility_ul');
    var items = document.querySelectorAll('.facility_item');
    if (!list || items.length < 2 || !window.matchMedia('(max-width: 767px)').matches) return;

    var second = items[1];
    var amount = second.offsetLeft - (window.innerWidth / 2) + (second.offsetWidth / 2);
    list.scrollTo({ left: amount, behavior: 'auto' });
    list.style.scrollSnapType = 'x mandatory';
  }

  function initVideoPause() {
    var video = document.querySelector('.p-mv-video');
    var button = document.querySelector('.js-mv-pause');
    if (!video || !button) return;

    button.addEventListener('click', function () {
      var willPause = !video.paused;
      if (willPause) {
        video.pause();
      } else {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      }

      button.classList.toggle('is-paused', willPause);
      button.setAttribute('aria-pressed', willPause ? 'true' : 'false');
      button.setAttribute('aria-label', willPause ? '背景動画を再生' : '背景動画を一時停止');
    });
  }

  function init() {
    initFacilityPosition();
    initVideoPause();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
